import { render, staticRenderFns } from "./ranking-top.vue?vue&type=template&id=0110fdc2&scoped=true"
import script from "./ranking-top.vue?vue&type=script&lang=js"
export * from "./ranking-top.vue?vue&type=script&lang=js"
import style0 from "./ranking-top.vue?vue&type=style&index=0&id=0110fdc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110fdc2",
  null
  
)

export default component.exports